/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const HotelElementGuest = require('./hotel_element_guest').default;
const HotelReservation = require('./hotel_reservation').default;
const CancelLimit = require('./cancel_limit').default;
const moment = require('moment-timezone');

const { toDomesticTel } = require('../util/string');

class HotelElement {
  static initClass() {
    this.prototype.hotelValidationError =
      'ホテル名を入力してください。\n予約が不要な場合、\nホテルの内容を削除してください。';

    this.prototype.timeValidationError = 'チェックイン以降を指定してください。';

    this.prototype.reservationNumberValidationError = '予約番号を入力してください。';
  }
  constructor(args) {
    if (args == null) {
      args = {};
    }
    args = snakeToCamelObject(args);
    _.assign(this, args);
    this.type = 'hotel';
    this.checkinDate = moment(args.checkinDate);
    this.checkoutDate = args.checkoutDate ? moment(args.checkoutDate) : this.checkinDate.add(1, 'day');
    this.peopleNum = args.peopleNum;
    this.latitude = args.latitude;
    this.longitude = args.longitude;
    if (!this.roomNum) {
      this.roomNum = 1;
    }
    if (!this.name) {
      this.name = '';
    }
    if (!this.roomType) {
      this.roomType = '';
    }
    if (!this.bedType) {
      this.bedType = '';
    }
    this.displayBedType = args.displayBedType || args.display_bed_type || '';
    this._bedTypeNoticeMessage = args.bedTypeNoticeMessage || args.bed_type_notice_message || null;
    if (!this.provider) {
      this.provider = 'ean';
    }
    if (!this.address) {
      this.address = '';
    }
    if (!this.tel) {
      this.tel = '';
    }
    if (!this.planName) {
      this.planName = '';
    }
    this.breakfast = (() => {
      switch (args.breakfast) {
        case true:
          return 'true';
        case false:
          return 'false';
        default:
          return 'null';
      }
    })();
    this.refundable = (() => {
      switch (args.refundable) {
        case true:
          return 'true';
        case false:
          return 'false';
        default:
          return 'null';
      }
    })();
    this.rawId = args.rawId;
    this.eanItineraryId = args.eanItineraryId;
    this.rapidItineraryId = args.rapidItineraryId;
    this.apiCanceledAt = args.apiCanceledAt ? moment(args.apiCanceledAt) : null;
    this.eanConfirmationNumber = args.eanConfirmationNumber;
    this.eanAffiliateConfirmationId = args.eanAffiliateConfirmationId;
    this.marketlogAvailable = args.marketlogAvailable;
    this.hotelElementGuests = _.map(args.hotelElementGuests, raw => new HotelElementGuest(raw));
    this.hotelReservation = args.hotelReservation ? new HotelReservation(args.hotelReservation) : undefined;
    this.mynaviReservationNumber = args.mynaviBookingInfo ? args.mynaviBookingInfo.reservationNo : '-';
    this.initialData = _.cloneDeep(this);
    this.hotelReservationNumber = args.hotelReservationNumber || '';
    this.rakutenTravelRConnectBookingInfos = _.map(args.rakutenTravelRConnectBookingInfos, raw => raw);
    this.detailPath = args.detailPath;
    this.cancelLimits = args.cancelLimits ? _.map(args.cancelLimits, raw => new CancelLimit(raw)) : [];
  }

  handleNameChange(value) {
    this.name = value;
    return app.render();
  }

  handlePlanNameChange(value) {
    this.planName = value;
    return app.render();
  }

  handleRoomTypeChange(value) {
    this.roomType = value;
    return app.render();
  }

  handleBedTypeChange(value) {
    this.bedType = value;
    return app.render();
  }

  handleCheckinDateChange(moment) {
    this.checkinDate = _.cloneDeep(moment);
    const nextDay = moment.add(1, 'day');
    if (this.checkoutDate <= nextDay) {
      this.checkoutDate = nextDay;
    }
    return app.render();
  }

  handleCheckoutDateChange(moment) {
    this.checkoutDate = _.cloneDeep(moment);
    const prevDay = moment.add(-1, 'day');
    if (this.checkinDate >= prevDay) {
      this.checkinDate = prevDay;
    }
    return app.render();
  }

  handleHotelProviderChange(value) {
    this.provider = value;
    return app.render();
  }

  handlePeopleNumChange(e) {
    e.preventDefault();
    this.peopleNum = e.target.value;
    return app.render();
  }

  handleRoomNumChange(value) {
    this.roomNum = parseInt(value);
    return app.render();
  }

  handleAddressChange(value) {
    this.address = value;
    return app.render();
  }

  handleTelChange(value) {
    this.tel = value;
    return app.render();
  }

  handleBreakfastChange(value) {
    this.breakfast = value;
    return app.render();
  }

  handleRefundableChange(value) {
    this.refundable = value;
    return app.render();
  }

  handleGuestLastNameChange(value) {
    this.guestLastName = value;
    return app.render();
  }

  handleGuestFirstNameChange(value) {
    this.guestFirstName = value;
    return app.render();
  }

  handleGuestLastNameKanaChange(value) {
    this.guestLastNameKana = value;
    return app.render();
  }

  handleGuestFirstNameKanaChange(value) {
    this.guestFirstNameKana = value;
    return app.render();
  }

  handleGuestTelChange(value) {
    this.guestTel = value;
    return app.render();
  }

  handleHotelReservationNumberChange(value) {
    this.hotelReservationNumber = value;
    return app.render();
  }

  handleIsForeignChange(value) {
    this.isForeign = value;
    return app.render();
  }

  addCancelLimit(limit) {
    this.cancelLimits.push(limit);
    return app.render();
  }

  removeCancelLimit(limit) {
    this.cancelLimits = _.reject(this.cancelLimits, l => l === limit);
    return app.render();
  }

  startDate() {
    return this.checkinDate;
  }

  endDate() {
    return this.checkoutDate;
  }

  staySchedule() {
    return `${this.checkinDate.format('YYYY-MM-DD')} 〜 ${this.checkoutDate.format('YYYY-MM-DD')}`;
  }

  stayDays() {
    return this.checkoutDate.diff(this.checkinDate, 'days');
  }

  title() {
    return '宿泊';
  }

  summary() {
    return `${this.checkinDate.format('YYYY-MM-DD')} 〜 ${this.checkoutDate.format('YYYY-MM-DD')}`;
  }

  dateStr() {
    return `${this.checkinDate.format('YYYY-MM-DD')}〜${this.checkoutDate.format('YYYY-MM-DD')}`;
  }

  detail(orderItem, opts) {
    if (orderItem == null) {
      orderItem = undefined;
    }
    if (opts == null) {
      opts = {};
    }
    const lines = this.structuredDetail(orderItem, opts);
    let s = '';
    for (var line of Array.from(lines)) {
      if (line.label) {
        s += line.label;
      }
      if (line.value) {
        s += line.value;
      }
      s += '\n';
    }
    return s;
  }

  structuredDetail(_orderItem, opts) {
    if (_orderItem == null) {
      _orderItem = undefined;
    }
    if (opts == null) {
      opts = {};
    }
    const lines = this.structuredHotelTypeDetail(opts);
    lines.push(this.structuredRoomTypeDetail());

    return lines;
  }

  hotelTypeDetail() {
    const lines = this.structuredHotelTypeDetail();
    let s = '';
    for (var line of Array.from(lines)) {
      if (line.label) {
        s += line.label;
      }
      if (line.value) {
        s += line.value;
      }
      s += '\n';
    }
    return s;
  }

  structuredHotelTypeDetail(opts) {
    if (opts == null) {
      opts = {};
    }
    const lines = [];
    lines.push({
      label: opts.inlineRestricted && this.restricted ? 'RESTRICTED!宿泊プラン：' : '宿泊プラン：',
      value: _.isEmpty(this.planName) ? '-' : this.planName,
      translate: true,
      restricted: this.restricted
    });
    if (this.provider !== 'agoda') {
      lines.push({
        label: '部屋タイプ：',
        value: _.isEmpty(this.roomType) ? '' : this.roomType,
        translate: true
      });
    }
    lines.push({
      label: '',
      value: this.breakfastDescription(),
      translate: true
    });
    return lines;
  }

  roomTypeDetail() {
    const lines = this.structuredRoomTypeDetail();
    let s = '';
    for (var line of Array.from(lines)) {
      if (line.label) {
        s += line.label;
      }
      if (line.value) {
        s += line.value;
      }
      s += '\n';
    }
    return s;
  }

  structuredRoomTypeDetail() {
    const lines = [];

    _.map(this.hotelElementGuests, (guest, i) =>
      lines.push(
        {
          label: '',
          value: '<' + (i + 1) + '室目>',
          translate: false
        },
        {
          label: '',
          value: guest.bedTypeDescriptionOverview(),
          translate: false
        },
        {
          label: '',
          value: guest.guestLastName + ' ' + guest.guestFirstName + ' (' + guest.guestTel + ')',
          translate: false
        }
      )
    );
    return lines;
  }

  mappingDescription() {
    return `ホテル：${this.name}`;
  }

  hotelMapAddressLink() {
    if (!_.isEmpty(this.address)) {
      return `https://www.google.com/maps/search/${this.address}`;
    } else if (!_.isEmpty(this.latitude) && !_.isEmpty(this.longitude)) {
      return `https://www.google.com/maps/search/${this.latitude}, ${this.longitude}`;
    }
  }

  providerString() {
    switch (this.provider) {
      case 'ean':
        return 'EAN';
      case 'rakuten':
        return '(旧)楽天トラベル';
      case 'new_rakuten':
        return '楽天トラベル';
      case 'jaran':
        return 'じゃらん';
      case 'expedia':
        return 'Expedia';
      case 'wbf':
        return 'WBF';
      case 'eps_rapid':
        return 'Eps Rapid';
      case 'jr':
        return 'JR';
      case 'ana_tabisaku':
        return 'ANA旅作';
      case 'racco':
        return 'Racco';
    }
  }

  addressDescription() {
    if (_.isEmpty(this.address)) {
      return '';
    } else {
      return `\n住所：${this.address}`;
    }
  }

  telDescription() {
    if (_.isEmpty(this.tel)) {
      return '';
    } else {
      return `\n電話番号：${toDomesticTel(this.tel)}`;
    }
  }

  planNameDescription() {
    if (_.isEmpty(this.planName)) {
      return '宿泊プラン：-';
    } else {
      return `\n宿泊プラン：${this.planName}`;
    }
  }

  roomTypeDescription() {
    if (_.isEmpty(this.roomType)) {
      return '';
    } else {
      return `\n部屋タイプ：${this.roomType}`;
    }
  }

  bedTypeDescription() {
    const displayType = this.displayBedType || this.bedType || '';
    if (_.isEmpty(displayType)) {
      return '\nベッドタイプ：-';
    }

    if (this._bedTypeNoticeMessage) {
      return `\nベッドタイプ：${displayType}\n${this._bedTypeNoticeMessage}`;
    } else {
      return `\nベッドタイプ：${displayType}`;
    }
  }

  bedTypeNoticeMessage() {
    return this._bedTypeNoticeMessage;
  }

  hasMultipleBedTypes() {
    return !!this._bedTypeNoticeMessage;
  }

  breakfastDescription() {
    let d = '\n朝食：';
    d += (() => {
      switch (this.breakfast) {
        case 'true':
          return '有り';
        case 'false':
          return '無し';
        case 'null':
          return 'お問合せください';
      }
    })();
    return d;
  }

  refundableDescription() {
    if (this.isPackage()) {
      return '';
    }

    let d = '\n返金：';
    d += (() => {
      switch (this.refundable) {
        case 'true':
        case true:
          return '可';
        case 'false':
        case false:
          return '不可';
        default:
          return 'お問合せください';
      }
    })();
    return d;
  }

  hotelReservationNumberDescription() {
    if (_.isEmpty(this.hotelReservationNumber)) {
      return '';
    } else {
      return `\nホテル予約番号：${this.hotelReservationNumber}`;
    }
  }

  description() {
    let d = `\
<宿泊>
■ご利用：${this.peopleNum}名${this.roomNum}室
■日程
${this.staySchedule()}
${this.stayDays()}泊
■ホテル
${this.name}\
`;
    d +=
      this.planNameDescription() +
      this.roomTypeDescription() +
      this.bedTypeDescription() +
      this.breakfastDescription() +
      this.refundableDescription() +
      this.addressDescription() +
      this.telDescription() +
      this.hotelReservationNumberDescription();

    d += _.map(
      this.hotelElementGuests,
      (guest, i) => `\


<${i + 1}室目>
${guest.bedTypeDescriptionOverview()}
■宿泊代表者
${guest.guestLastName} ${guest.guestFirstName}
${guest.guestTel}\
`
    );

    return d;
  }

  marketLogType() {
    return this.type;
  }

  isAir() {
    return false;
  }

  isRailway() {
    return false;
  }

  isHotel() {
    return true;
  }

  isPackage() {
    return !!this.packageType || this.provider === 'wbf';
  }

  isCancelable(orderItemCategory) {
    if (this.provider !== 'mynavi' || orderItemCategory === 'cancel' || this.apiCanceledAt !== null) {
      return false;
    }
    return this.checkinDate >= moment.tz('Asia/Tokyo').add(1, 'day').startOf('day');
  }

  isCanceled(orderItemCategory) {
    return this.provider === 'mynavi' && this.apiCanceledAt !== null;
  }

  validationErrors(orderItemStatus) {
    let errors = [];
    const needStatusGuard = orderItemStatus === 7 || orderItemStatus === 13;
    if (this.name === '') {
      errors.push(this.hotelValidationError);
    }
    if (this.checkoutDate < this.checkinDate) {
      errors.push(this.timeValidationError);
    }
    if (this.hotelReservationNumber === '' && needStatusGuard) {
      errors.push(this.reservationNumberValidationError);
    }
    errors = errors.concat(_.flatMap(this.cancelLimits, limit => limit.validationErrors()));
    return errors;
  }

  updateParams() {
    return {
      type: this.type,
      checkin_date: this.checkinDate.format('YYYY-MM-DD'),
      checkout_date: this.checkoutDate.format('YYYY-MM-DD'),
      name: this.name,
      provider: this.provider,
      people_num: this.peopleNum,
      room_num: this.roomNum,
      plan_name: this.planName,
      room_type: this.roomType,
      bed_type: this.bedType,
      address: this.address,
      tel: this.tel,
      breakfast: (() => {
        switch (this.breakfast) {
          case 'true':
            return true;
          case 'false':
            return false;
          case 'null':
            return null;
        }
      })(),
      refundable: (() => {
        switch (this.refundable) {
          case 'true':
            return true;
          case 'false':
            return false;
          case 'null':
            return null;
        }
      })(),
      guest_last_name: this.guestLastName,
      guest_first_name: this.guestFirstName,
      guest_last_name_kana: this.guestLastNameKana,
      guest_first_name_kana: this.guestFirstNameKana,
      guest_tel: this.guestTel,
      raw_id: this.rawId,
      ean_itinerary_id: this.eanItineraryId,
      rapid_itinerary_id: this.rapidItineraryId,
      ean_confirmation_number: this.eanConfirmationNumber,
      ean_affiliate_confirmation_id: this.eanAffiliateConfirmationId,
      api_canceled_at: this.apiCanceledAt != null ? this.apiCanceledAt.format() : undefined,
      hotel_reservation: this.hotelReservation,
      hotel_reservation_number: this.hotelReservationNumber,
      is_foreign: this.isForeign,
      rakuten_hotel_reservation_ids: _.map(
        this.rakutenTravelRConnectBookingInfos,
        info => info['hotel_reservation_id']
      ),
      cancel_limits_attributes: _.map(this.cancelLimits, limit => limit.updateParams())
    };
  }

  restore() {
    return _.assign(this, _.cloneDeep(this.initialData));
  }
}
HotelElement.initClass();

module.exports = HotelElement;
